export const FETCH_USERS_SUCCESS = 'fetchUsersSuccess';
export const UPDATE_ACTIVE_SORT_FIELD_USERS_M = 'updateActiveSortFieldUsersMutation';
export const UPDATE_SEARCH_USERS_M = 'updateSearchUsersMutation';
export const CLEAR_SEARCH_USERS_M = 'clearSearchUsersMutation';
export const FETCH_ADMIN_USER_SUCCESS = 'fetchAdminUserSuccess';
